module.exports = __webpack_public_path__ + "static/media/Bariatric-Behavioral Eating Patterns Questionnaire-2@3x.7594dca2.png";